'use client'

import { AppBar, styled } from '@mui/material'

export const StyledHeader = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none !important',
  height: '141px',
  backgroundColor: 'white',
  top: 0,
  position: 'fixed',
  zIndex: 10,
  /* transition: theme.transitions.create(
      ['transform', 'height'],
      { duration: theme.transitions.duration.standard }
    ),	 */

  '&.page-scrolled':{
	  height:'60px',
   '.header-wrapper': {
    transform: 'translateY(-80px)',
  }},

  '.header-wrapper': {
    maxWidth: '1200px',
    width: '100%',
    margin: '0 auto',
    boxSizing: 'border-box',
    position: 'relative',
    zIndex: 1,
    padding: theme.spacing(0, 1),
    /* transition: theme.transitions.create(
      ['transform', 'opacity', 'max-height'],
      { duration: theme.transitions.duration.standard }
    ), */
  },

  '.hcp-line': {
    textAlign: 'center',
    height: '34px',
    lineHeight: '34px',
    fontWeight: '600',
    color: 'rgba(0, 0, 0, 0.87)',
    margin: 0,
    [theme.breakpoints.down('md')]: {
      lineHeight: '16px',
      paddingTop: '2px',
    },
  },

  '.mobile-only': {
    display: 'none',
      [theme.breakpoints.down('md')]: {
        display: 'block'
    },
  },

  '.mobile-container': {
    height: '54px',
  },

  [theme.breakpoints.up('md')]: {
    '>.content-wrapper.wide': {
      padding: theme.spacing(0, 1, 0),
    },
  },
}))
